import { render } from "./EmployeeProcessedRequests.vue?vue&type=template&id=5edc6e6e"
import script from "./EmployeeProcessedRequests.vue?vue&type=script&lang=js"
export * from "./EmployeeProcessedRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__